import * as actionTypes from './types';
import {
  BackofficeFilters,
  BackofficeTab,
  CuratedJobRequestsResponse,
  CuratedPostulationsResponse,
  ValidationAction,
} from '../../types/backoffice.ts';
import { projectDocumentationService } from '../../services/projectDocumentationService.ts';
import { openMainModal } from './profileActions';
import axios from '../../axios';

export const setActiveTab = (tab: BackofficeTab) => ({
  type: actionTypes.SET_BACKOFFICE_ACTIVE_TAB,
  payload: tab,
});

export const fetchPendingAnteProyectos = (page: number = 1, filters?: Partial<BackofficeFilters>) => {
  return async (dispatch: any) => {
    dispatch({ type: actionTypes.FETCH_PENDING_ANTEPROYECTOS_LOADING });
    
    try {
      const response = await projectDocumentationService.getPendingProjectDocumentations(page, 9, filters);
      
      dispatch({
        type: actionTypes.FETCH_PENDING_ANTEPROYECTOS_SUCCESS,
        payload: response,
      });
    } catch (error: any) {
      console.error('Error fetching pending project documentations:', error);
      dispatch({
        type: actionTypes.FETCH_PENDING_ANTEPROYECTOS_ERROR,
        payload: error.message || 'Error al cargar documentación',
      });
    }
  };
};

export const fetchBackofficeStats = () => {
  return async (dispatch: any, getState: any) => {
    dispatch({ type: actionTypes.FETCH_BACKOFFICE_STATS_LOADING });
    
    try {
      const stats = await projectDocumentationService.getProjectDocumentationStats();
      const identityCount = getState().register?.workBagUsersToValidate?.length || 0;
      
      dispatch({
        type: actionTypes.FETCH_BACKOFFICE_STATS_SUCCESS,
        payload: {
          ...stats,
          totalPendingIdentities: identityCount,
        },
      });
    } catch (error) {
      console.error('Error fetching backoffice stats:', error);
    }
  };
};

export const setSelectedAnteProyecto = (anteProyecto: any) => ({
  type: actionTypes.SET_SELECTED_ANTEPROYECTO,
  payload: anteProyecto,
});

export const setBackofficeFilters = (filters: Partial<BackofficeFilters>) => {
  return (dispatch: any, getState: any) => {
    dispatch({
      type: actionTypes.SET_BACKOFFICE_FILTERS,
      payload: filters,
    });
    
    const state = getState();
    const updatedFilters = { ...state.backoffice.filters, ...filters };
    dispatch(fetchPendingAnteProyectos(1, updatedFilters));
  };
};

export const setBackofficePage = (page: number) => {
  return (dispatch: any, getState: any) => {
    dispatch({
      type: actionTypes.SET_BACKOFFICE_PAGE,
      payload: page,
    });
    
    const state = getState();
    dispatch(fetchPendingAnteProyectos(page, state.backoffice.filters));
  };
};

export const validateAnteProyecto = (validation: ValidationAction) => {
  return async (dispatch: any, getState: any) => {
    dispatch({ type: actionTypes.VALIDATE_ANTEPROYECTO_LOADING });
    
    try {
      if (validation.isApproved) {
        await projectDocumentationService.approveProjectDocumentation(validation.id, validation.adminNote);
        
        dispatch(openMainModal({
          title: '¡Ante Proyecto Aprobado!',
          body: 'El ante proyecto ha sido aprobado exitosamente y ahora será visible en el marketplace.',
          iconType: 'success',
          isSuccess: true,
          confirmHandler: null,
        }));
      } else {
        await projectDocumentationService.rejectProjectDocumentation(validation.id, validation.reason || 'No especificado');
        
        dispatch(openMainModal({
          title: '¡Ante Proyecto Rechazado!',
          body: 'El ante proyecto ha sido rechazado. El usuario recibirá una notificación.',
          iconType: 'error',
          isSuccess: true,
          confirmHandler: null,
        }));
      }
      
      dispatch({
        type: actionTypes.VALIDATE_ANTEPROYECTO_SUCCESS,
        payload: { id: validation.id },
      });
      
      const state = getState();
      dispatch(fetchPendingAnteProyectos(state.backoffice.pagination.currentPage, state.backoffice.filters));
      dispatch(fetchBackofficeStats());
      
      return { success: true };
    } catch (error: any) {
      console.error('Error validating anteproyecto:', error);
      
      dispatch(openMainModal({
        title: '¡Error!',
        body: 'No se pudo procesar la validación del ante proyecto. Por favor, inténtalo nuevamente.',
        iconType: 'error',
        isSuccess: true,
        confirmHandler: null,
      }));
      
      dispatch({
        type: actionTypes.VALIDATE_ANTEPROYECTO_ERROR,
        payload: error.message,
      });
      return { success: false, error: error.message };
    }
  };
};

export const fetchCuratedJobRequests = () => {
  return async (dispatch: any) => {
    dispatch({ type: actionTypes.FETCH_CURATED_JOB_REQUESTS_LOADING });
    try {
      const authToken = localStorage.getItem("access-Token-Edify");
      const config = authToken
        ? { headers: { Authorization: `Bearer ${authToken}` } }
        : undefined;
      const response = await axios.get<CuratedJobRequestsResponse>('/job-request/admin/curated', config);
      dispatch({
        type: actionTypes.FETCH_CURATED_JOB_REQUESTS_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      dispatch({
        type: actionTypes.FETCH_CURATED_JOB_REQUESTS_ERROR,
        payload: error?.response?.data?.message || error.message || 'Error al cargar avisos curados',
      });
    }
  };
};

export const fetchCuratedPostulations = (jobRequestId: number) => {
  return async (dispatch: any) => {
    dispatch({ type: actionTypes.FETCH_CURATED_POSTULATIONS_LOADING });
    try {
      const authToken = localStorage.getItem("access-Token-Edify");
      const config = authToken
        ? { headers: { Authorization: `Bearer ${authToken}` } }
        : undefined;
      const response = await axios.get<CuratedPostulationsResponse>(
        `/job-request/admin/curated/${jobRequestId}/postulations`,
        config
      );
      dispatch({
        type: actionTypes.FETCH_CURATED_POSTULATIONS_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      dispatch({
        type: actionTypes.FETCH_CURATED_POSTULATIONS_ERROR,
        payload: error?.response?.data?.message || error.message || 'Error al cargar postulaciones',
      });
    }
  };
};

